<template>
  <div id="holder">
    <div class="border">
      <img src="@/assets/wa_logo.png" alt="logo">
      <button @click="direct_to_wa">Scrivici su WhatsApp</button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {
      text:'Benvenuto su TIM'
    }
  },
  methods: {
    direct_to_wa() {
      location.href = `https://api.whatsapp.com/send?phone=393666677166&text=Ciao!%20Vorrei%20delle%20informazioni%20sulle%20offerte%20TIM%20per%20la%20mia%20casa.`;
    }
  }
  
}
</script>

<style>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

  :focus {
  outline: 0;
  }
  
  #holder {
    display:flex;
    background-image:linear-gradient(
      #57ce64, #26b43d
    );
    overflow: visible;
    border-radius: 50px 50px 50px 50px;
    width:235px;
    height:auto;
    margin-left:5px;
    box-shadow: 1px 1px 4px 0px rgb(197, 197, 197);
    cursor: pointer;
    outline: none;
  }

  .border {
    display:flex;
    flex-flow: row nowrap;
    overflow: visible;
    box-shadow: inset 0px 0px 0px 4px white;
    border-radius: 50px 50px 50px 50px;
    width:100%;
    height:100%;
  }

  button {
    background-color: transparent;
    color: white;
    border-style: none;
    margin-left:7px;
    font-size: 16px;
    font-family: "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif; 
    font-weight: bold;
    padding-right: 20px;
    cursor: pointer;
  }

  img {
    width:auto;
    height:50px;
    transform: translateX(-5px);
  }

  @media only screen and (min-width: 600px) {
    #holder {
      width:245px;
    }

    button {
      vertical-align: middle;
      margin-bottom: 4px; 
    }
  }
</style>
